import { render, staticRenderFns } from "./footerIndex.vue?vue&type=template&id=1ca7a6e9&"
import script from "./footerIndex.vue?vue&type=script&lang=js&"
export * from "./footerIndex.vue?vue&type=script&lang=js&"
import style0 from "./footerIndex.vue?vue&type=style&index=0&id=1ca7a6e9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports